var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14C10.8133 14 9.65328 13.6481 8.66658 12.9888C7.67989 12.3295 6.91085 11.3925 6.45673 10.2961C6.0026 9.19975 5.88378 7.99335 6.11529 6.82946C6.3468 5.66558 6.91825 4.59648 7.75736 3.75736C8.59648 2.91825 9.66558 2.3468 10.8295 2.11529C11.9933 1.88378 13.1997 2.0026 14.2961 2.45673C15.3925 2.91085 16.3295 3.67989 16.9888 4.66658C17.6481 5.65328 18 6.81331 18 8C17.9981 9.59073 17.3654 11.1158 16.2406 12.2406C15.1158 13.3654 13.5907 13.9981 12 14Z",
    fill: "#B2B1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7 12.7129C14.6455 13.5455 13.3411 13.9983 11.9975 13.9983C10.6539 13.9983 9.34955 13.5455 8.29501 12.7129C6.61287 13.3837 5.14464 14.499 4.04731 15.9396C2.94998 17.3802 2.26479 19.092 2.06501 20.8919C2.03641 21.1555 2.11368 21.4197 2.27983 21.6263C2.44598 21.833 2.6874 21.9652 2.95101 21.9939L20.94 21.9999C21.0805 22 21.2195 21.9705 21.3478 21.9133C21.4762 21.8562 21.591 21.7726 21.6849 21.668C21.7788 21.5635 21.8496 21.4404 21.8927 21.3066C21.9358 21.1729 21.9502 21.0316 21.935 20.8919C21.7346 19.0918 21.0489 17.3799 19.951 15.9393C18.8532 14.4987 17.3845 13.3835 15.702 12.7129H15.7Z",
    fill: "#5D87FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccount);
export default __webpack_public_path__ + "static/media/icon-account.4f72ef0a74d560a5c1d65918b987d4d0.svg";
export { ForwardRef as ReactComponent };